import { render, staticRenderFns } from "./PmauPrompts.vue?vue&type=template&id=3bd8478e&"
import script from "./PmauPrompts.vue?vue&type=script&lang=js&"
export * from "./PmauPrompts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports